import { Button, Carousel, Col, Row } from "react-bootstrap"
import { url_images } from "../../lib/backend/data"

const { useSelector } = require("react-redux")

const FooterText = props => {
    const {
        zone
    } = props
    const sitio = useSelector(state => state.sitio)

    if(sitio.modules?.footer_text?.active !== true) return null
    if(!sitio.modules?.footer_text?.items?.texto?.value) return null
    
    return <div className="text-center">
        <p className="mb-0">{sitio.modules?.footer_text?.items?.texto?.value}</p>
    </div>
}

export default FooterText